import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.FormTrackingSubmits = routerStyxie({ actions: ['index', 'show']})
